import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import ContinuityBook from "@/pages/continuity/ContinuityBook";
import TodaysCallSheet from "@/pages/continuity/TodaysCallSheet";

// Standalone page — used from ProjectCubicles (non-TV shoots) via a
// header nav link. TV dashboards mount ContinuityBook inline in
// ProjectDashboard so this page isn't the only surface.
export default function ProjectContinuity() {
  const { id } = useParams();
  const [project, setProject] = useState(null);

  useEffect(() => {
    let dead = false;
    api.get(`/projects/${id}`)
      .then(({ data }) => {
        if (!dead) setProject(data.project || data);
      })
      .catch((err) => {
        toast.error(formatApiErrorDetail(err.response?.data?.detail)
                     || "Could not load project");
      });
    return () => { dead = true; };
  }, [id]);

  return (
    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-8"
         data-testid="project-continuity-page">
      <Link to={`/projects/${id}/cubicles`}
            className="text-[10px] tracking-[0.25em] uppercase text-white/55 hover:text-white inline-flex items-center gap-1.5"
            data-testid="continuity-back-to-cubicles">
        <ArrowLeft size={12} /> Back to project
      </Link>
      <div className="mt-3">
        <div className="text-[10px] tracking-[0.3em] uppercase text-white/50">
          Continuity Book
        </div>
        <h1 className="font-display text-4xl sm:text-5xl uppercase tracking-tight mt-1"
            data-testid="project-continuity-title">
          {project?.title || "Loading…"}
        </h1>
      </div>
      <div className="mt-6 space-y-6">
        <TodaysCallSheet projectId={id} />
        <ContinuityBook projectId={id} />
      </div>
    </div>
  );
}
